import { html, TemplateResult, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import globalStyles from './styles/outline-list-block-grid.global.pcss?inline';
import encapsulatedStyles from './styles/outline-list-block-grid.inner.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';

const componentName = 'outline-list-block-grid';

/**
 * The OutlineListBlockGrid component
 * @element outline-list-block-grid
 */
@customElement('outline-list-block-grid')
export class OutlineListBlockGrid extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  render(): TemplateResult {
    return html`
      <div class="outline-list-block-grid">
        <div class="heading">
          <slot name="heading"></slot>
        </div>
        <div class="grid">
          <slot></slot>
        </div>
      </div>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineListBlockGrid;
  }
}
